import { ApiClient } from "@/shared/services/api-client";
import { PutUsersPutRequestModel, PutUsersPutResponseModel } from "@/features/user/services/put-users-model";
import { MoneyLinkException } from "@/shared/utils/custom-exception";

export class PutUsersApi {
  /**
   * 利用者情報更新API
   */
  public putUsers = async (
    param: PutUsersPutRequestModel
  ): Promise<PutUsersPutResponseModel> => {
    const path = `/api/users`;
    const res = await ApiClient.instance.put<PutUsersPutResponseModel>({
      path: path,
      params: param as NonNullable<unknown>,
    });

    if (res.ok === false) {
      throw MoneyLinkException.fromServer({ response: res });
    }

    return res.body;
  };
}
